import { createContext, useState, useEffect } from 'react';
import { jwtDecode } from 'jwt-decode'; // ✅ correcta
import axios from "axios";


export const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [token, setToken] = useState(localStorage.getItem('token'));
  const [roles, setRoles] = useState([]);
  const [user, setUser] = useState(null);

  useEffect(() => {
    if (token) {
      const decoded = jwtDecode(token);
      const extractedRoles = decoded.roles?.map(r => r.authority || r) || [];
      setRoles(extractedRoles);
      setUser(decoded.sub || decoded.username || null);
    } else {
      setRoles([]);
      setUser(null);
    }
  }, [token]);

  const login = (jwt) => {
    localStorage.setItem('token', jwt);
    setToken(jwt);
  };

  const logout = async () => {
    try {
      await axios.post("/api/auth/logout", null, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`
        }
      });
    } catch (e) {
      // aunque falle, cerramos sesión igual
    } finally {
      localStorage.removeItem("token");
      localStorage.removeItem("roles");
      window.location.href = "/login";
    }
  };

  return (
    <AuthContext.Provider value={{ token, roles, user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}
